var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "loading-spinner" }, [
      _c("i", { staticClass: "fa fa-spinner fa-spin fa-3x fa-fw" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }